import React from 'react';

export const SubrowDefaultContent = ({ dataRow, subrows }) => {
    React.useEffect(() => {
        // Actions that are executed after the renderer's HTML is rendered
        if (!subrows?.showExpandColumn) {
            // get all elements td.reset-expansion-style
            const tdElements = document.querySelectorAll('tr > td.reset-expansion-style');
            // const tableRows = document.querySelectorAll('tbody  tr');

            // We hide the elements <tr> that are parents of td.reset-expansion-style
            tdElements.forEach((element) => {
                if (element?.parentElement?.display !== 'none') {
                    element.parentElement.style.display = 'none';
                    // element.parentElement.remove();
                }
            });
            // eslint-disable-next-line no-console
            // console.log('El HTML del renderer fue renderizado');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div id='sub-row' style={subrows?.showExpandColumn ? {} : { display: 'none' }}>
            <table>
                <tbody>
                    {subrows?.row?.map((label, index) => {
                        const keyRow = label?.dataField;
                        const valueRow = dataRow[keyRow];
                        // Check if keyRow has a rigth valueRow else show no data
                        if (Object.hasOwnProperty.call(dataRow, keyRow) && valueRow !== undefined) {
                            return (
                                <tr key={keyRow + dataRow.id}>
                                    {/* Key row */}
                                    <td style={{ textAlign: 'left' }}>
                                        <div className='d-flex flex-column text-left'>
                                            <span>{label.text /* key row translated */}</span>
                                        </div>
                                    </td>
                                    {/* Value row */}
                                    <td style={{ textAlign: 'left' }}>
                                        <div className='d-flex flex-column text-left'>
                                            {valueRow}
                                        </div>
                                    </td>
                                </tr>
                            );
                        }
                        // Show no data
                        return (index === 1) && (
                            <tr key={'tr' + dataRow?.id}>
                                <td style={{ textAlign: 'left' }}>
                                    <div className='d-flex flex-column text-left'>
                                        <span>No hay datos</span>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
